import { Tokens } from '@/common/domain/token/Tokens';

export class Wallet {
  constructor(public readonly balance: Tokens) {}
}
